import React from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import { Link, LinkItem, LinksList, TextLabel } from './horizontal-links.styles';

const HorizontalLinks = ({
  data,
  handleHorizontalLinksClick
}) => {
  const {
    linksList = []
  } = data;
  return /*#__PURE__*/React.createElement(LinksList, {
    "data-testid": 'horizontal-links-elem'
  }, linksList.map((link, index) => /*#__PURE__*/React.createElement(LinkItem, {
    key: `link-item-${index}`
  }, link.url ? /*#__PURE__*/React.createElement("div", {
    onClick: () => handleHorizontalLinksClick(link.label)
  }, /*#__PURE__*/React.createElement(Link, {
    href: link.url
  }, link.label)) : /*#__PURE__*/React.createElement(TextLabel, null, link.label))));
};

HorizontalLinks.defaultProps = {
  data: {
    linksList: []
  },
  handleHorizontalLinksClick: () => {}
};
process.env.NODE_ENV !== "production" ? HorizontalLinks.propTypes = {
  data: shape({
    linksList: arrayOf(shape({
      url: string,
      label: string
    }))
  }),
  handleHorizontalLinksClick: func
} : void 0;
export default HorizontalLinks;